import React from "react";
import PropTypes from "prop-types";
import { Spin } from "antd";

const LoadingWrapper = props => {
  let { loading, error, errorMsg, spinSize, children, style, ...other } = props;
  const loadingContainerStyle = {
    width: "100%",
    ...style,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };
  return loading ? (
    <div {...other} style={loadingContainerStyle}>
      <Spin size={spinSize} />
    </div>
  ) : error ? (
    <div {...other} style={loadingContainerStyle}>
      {errorMsg ? errorMsg : "An error occurred."}
    </div>
  ) : (
    <div {...other} style={{ width: "100%", ...style }}>
      {children}
    </div>
  );
};

LoadingWrapper.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.bool,
  errorMsg: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  spinSize: PropTypes.oneOf(["small", "large"])
};

export default LoadingWrapper;
